// import React, { useEffect, useState } from 'react';
// import {
//   Modal,
//   Form,
//   Input,
//   Select,
//   Button,
//   Progress,
//   Avatar,
//   Typography,
//   message,
//   Switch
// } from 'antd';
// import ColorHash from 'color-hash';
// import { useDispatch, useSelector } from 'react-redux';
// import { getAllClients, getAllProjects } from 'pages/Tasks/redux/slice';
// import {
//   assignProjectToUser,
//   fetchStaffingData,
//   fetchStaffingUsers
// } from '../redux/slice';

// const { Text } = Typography;
// const { Option } = Select;
// const colorHash = new ColorHash({ lightness: 0.7 });

// const getInitials = (name) => {
//   if (!name) return 'U';
//   return name
//     .split(' ')
//     .map((word) => word[0])
//     .join('')
//     .toUpperCase();
// };

// const AssignmentModal = ({ visible, open, onClose, member }) => {
//   const [form] = Form.useForm();
//   const [allocationValue, setAllocationValue] = useState(null);
//   const [clients, setClients] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [utilizationType, setUtilizationType] = useState('active');
//   const isOpen = visible || open;
//   const dispatch = useDispatch();

//   const currentUtilization = member?.workload || 0;
//   const availableUtilization = Math.max(0, 100 - currentUtilization);

//   useEffect(() => {
//     if (isOpen) {
//       dispatch(getAllClients()).then((res) => {
//         if (res?.payload?.success) {
//           setClients(res.payload.data || []);
//         }
//       });
//       dispatch(getAllProjects()).then((res) => {
//         if (res?.payload?.success) {
//           setProjects(res.payload.data || []);
//         }
//       });
//     }
//   }, [dispatch, isOpen]);

//   const getUtilizationColor = () => {
//     if (currentUtilization > 100) return '#ff4d4f';
//     if (currentUtilization > 80) return '#faad14';
//     return '#52c41a';
//   };

//   // const handleFinish = (values) => {
//   //   const payload = {
//   //     project_id: values.project,
//   //     user_id: member?.id,
//   //     // project_role_master_id: 1,
//   //     utilization_type: member?.status || 'active',
//   //     utilization_percentage: values.allocation
//   //   };

//   //   dispatch(assignProjectToUser(payload)).then((res) => {
//   //     if (res?.payload?.success) {
//   //       dispatch(fetchStaffingData());
//   //       dispatch(fetchStaffingUsers());
//   //     }
//   //   });
//   //   console.log('Assignment Payload:', payload);

//   //   form.resetFields();
//   //   onClose();
//   // };
//   const handleFinish = (values) => {
//     const payload = {
//       project_id: values.project,
//       user_id: member?.id,
//       utilization_type: utilizationType, // ✅ from state now
//       utilization_percentage: values.allocation
//     };

//     dispatch(assignProjectToUser(payload)).then((res) => {
//       if (res?.payload?.success) {
//         dispatch(fetchStaffingData());
//         dispatch(fetchStaffingUsers());
//       }
//     });

//     form.resetFields();
//     onClose();
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     onClose();
//   };

//   return (
//     <Modal
//       visible={isOpen}
//       open={isOpen}
//       // title="Assign Project"
//       onCancel={handleCancel}
//       footer={null}
//       centered
//       destroyOnClose
//       maskClosable
//       width={500}
//     >
//       <Form form={form} layout="vertical" onFinish={handleFinish}>
//         <h3 className="text-[rgba(0,0,0,0.85)]" style={{ fontWeight: 'bold' }}>
//           Assign Project
//         </h3>
//         {/* Employee Info */}
//         <Form.Item className="mb-[10px]">
//           <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//             <Avatar
//               style={{
//                 backgroundColor: member?.name
//                   ? colorHash.hex(member.name)
//                   : '#1677ff',
//                 color: '#fff',
//                 fontWeight: 600
//               }}
//             >
//               {getInitials(member?.name)}
//             </Avatar>
//             <Text strong>{member?.name || 'Unknown User'}</Text>
//           </div>
//         </Form.Item>

//         {/* Utilization Progress */}
//         <div
//           style={{
//             marginBottom: 16,
//             border: '1px solid #D1D5DB',
//             padding: '6px 10px',
//             borderRadius: '10px'
//           }}
//         >
//           <Text>Current Utilization</Text>
//           <Progress
//             percent={currentUtilization}
//             status="active"
//             showInfo={false}
//             strokeColor={getUtilizationColor()}
//             style={{ marginTop: 4 }}
//           />
//           <div
//             style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               fontSize: 12,
//               marginTop: 4
//             }}
//           >
//             <Text type="secondary">Available: {availableUtilization}%</Text>
//             <Text type="secondary">Current: {currentUtilization}%</Text>
//           </div>
//         </div>

//         {/* Client Dropdown */}
//         <Form.Item
//           label="Client"
//           name="client"
//           rules={[{ required: true, message: 'Please select a client' }]}
//         >
//           <Select
//             placeholder="Select Client"
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {clients.map((client) => (
//               <Option key={client.id} value={client.id}>
//                 {client.client_name}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         {/* Project Dropdown */}
//         <Form.Item
//           label="Project"
//           name="project"
//           rules={[{ required: true, message: 'Please select a project' }]}
//         >
//           <Select
//             placeholder="Select Project"
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {projects.map((project) => (
//               <Option key={project.id} value={project.id}>
//                 {project.project}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         {/* Utilization Input */}
//         <Form.Item
//           label={`Utilization (Max: ${availableUtilization}%)`}
//           name="allocation"
//           validateStatus={
//             allocationValue > availableUtilization ? 'warning' : undefined
//           }
//           help={
//             allocationValue > availableUtilization
//               ? `⚠ Allocation exceeds available limit of ${availableUtilization}%`
//               : null
//           }
//           rules={[
//             { required: true, message: 'Please enter allocation percentage' },
//             {
//               type: 'number',
//               min: 1,
//               message: `Must be at least 1%`
//             }
//           ]}
//           getValueFromEvent={(e) => {
//             const val = Number(e.target.value);
//             setAllocationValue(val);
//             return val;
//           }}
//         >
//           <Input
//             addonAfter="%"
//             type="number"
//             placeholder="Enter utilization"
//             min={1}
//           />
//         </Form.Item>

//         {/* <Form.Item label="Utilization Type">
//           <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//             <span
//               style={{
//                 color: utilizationType === 'active' ? '#1890ff' : '#595959'
//               }}
//             >
//               Active
//             </span>
//             <Switch
//               checked={utilizationType === 'upcoming'}
//               onChange={(checked) =>
//                 setUtilizationType(checked ? 'upcoming' : 'active')
//               }
//             />
//             <span
//               style={{
//                 color: utilizationType === 'upcoming' ? '#1890ff' : '#595959'
//               }}
//             >
//               Upcoming
//             </span>
//           </div>
//         </Form.Item> */}
//         <Form.Item label="Utilization Type">
//           {/* <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}> */}
//           <Button.Group>
//             <Button
//               type={utilizationType === 'active' ? 'primary' : 'default'}
//               onClick={() => setUtilizationType('active')}
//             >
//               Active
//             </Button>
//             <Button
//               type={utilizationType === 'upcoming' ? 'primary' : 'default'}
//               onClick={() => setUtilizationType('upcoming')}
//             >
//               Upcoming
//             </Button>
//           </Button.Group>
//           {/* </div> */}
//         </Form.Item>

//         {/* Footer Buttons */}
//         {/* <div
//           style={{
//             display: 'flex',
//             justifyContent: 'flex-end',
//             gap: 8,
//             marginTop: 24
//           }}
//         >
//           <Button onClick={handleCancel}>Cancel</Button>
//           <Button type="primary" htmlType="submit">
//             Assign
//           </Button>
//         </div> */}
//         <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
//           <Button
//             onClick={handleCancel}
//             className="font-bold border border-blue-500 text-blue-500"
//           >
//             Cancel
//           </Button>
//           <Button className="font-bold" type="primary" htmlType="submit">
//             Assign
//           </Button>
//         </div>
//       </Form>
//     </Modal>
//   );
// };

// export default AssignmentModal;

// import React, { useEffect, useState } from 'react';
// import {
//   Modal,
//   Form,
//   Input,
//   Select,
//   Button,
//   Progress,
//   Avatar,
//   Typography,
//   message
// } from 'antd';
// import ColorHash from 'color-hash';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchUserRoles,
//   assignProjectToUser,
//   fetchStaffingData,
//   fetchStaffingUsers
// } from '../redux/slice';
// import { getAllClients, getAllProjects } from 'pages/Tasks/redux/slice';

// const { Text } = Typography;
// const { Option } = Select;
// const colorHash = new ColorHash({ lightness: 0.7 });

// const getInitials = (name) => {
//   if (!name) return 'U';
//   return name
//     .split(' ')
//     .map((word) => word[0])
//     .join('')
//     .toUpperCase();
// };

// const AssignmentModal = ({ visible, open, onClose, member }) => {
//   const [form] = Form.useForm();
//   const [allocationValue, setAllocationValue] = useState(null);
//   const [clients, setClients] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [utilizationType, setUtilizationType] = useState('active');
//   const isOpen = visible || open;
//   const dispatch = useDispatch();

//   const currentUtilization = member?.workload || 0;
//   const availableUtilization = Math.max(0, 100 - currentUtilization);

//   useEffect(() => {
//     if (isOpen) {
//       dispatch(getAllClients()).then((res) => {
//         if (res?.payload?.success) {
//           setClients(res.payload.data || []);
//         }
//       });
//       dispatch(getAllProjects()).then((res) => {
//         if (res?.payload?.success) {
//           setProjects(res.payload.data || []);
//         }
//       });
//       dispatch(fetchUserRoles()).then((res) => {
//         if (res?.payload?.success) {
//           setRoles(res.payload.data || []);
//         }
//       });
//     }
//   }, [dispatch, isOpen]);

//   console.log(projects, 'setProjects');

//   const getUtilizationColor = () => {
//     if (currentUtilization > 100) return '#ff4d4f';
//     if (currentUtilization > 80) return '#faad14';
//     return '#52c41a';
//   };

//   const handleFinish = (values) => {
//     const payload = {
//       project_id: values.project,
//       user_id: member?.id,
//       project_role_master_id: values.role,
//       utilization_type: utilizationType,
//       utilization_percentage: values.allocation
//     };

//     dispatch(assignProjectToUser(payload)).then((res) => {
//       if (res?.payload?.success) {
//         dispatch(fetchStaffingData());
//         dispatch(fetchStaffingUsers());
//       }
//     });

//     form.resetFields();
//     onClose();
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     onClose();
//   };

//   return (
//     <Modal
//       visible={isOpen}
//       open={isOpen}
//       onCancel={handleCancel}
//       footer={null}
//       centered
//       destroyOnClose
//       maskClosable
//       width={500}
//     >
//       <Form form={form} layout="vertical" onFinish={handleFinish}>
//         <h3
//           className="text-[rgba(0,0,0,0.85)]"
//           style={{ fontWeight: 'bold', marginTop: '-7px' }}
//         >
//           Assign Project
//         </h3>

//         <Form.Item className="mb-[10px]">
//           <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//             <Avatar
//               style={{
//                 backgroundColor: member?.name
//                   ? colorHash.hex(member.name)
//                   : '#1677ff',
//                 color: '#fff',
//                 fontWeight: 600
//               }}
//             >
//               {getInitials(member?.name)}
//             </Avatar>
//             <Text strong>{member?.name || 'Unknown User'}</Text>
//           </div>
//         </Form.Item>

//         <div
//           style={{
//             marginBottom: 16,
//             border: '1px solid #D1D5DB',
//             padding: '6px 10px',
//             borderRadius: '10px'
//           }}
//         >
//           <Text>Current Utilization</Text>
//           <Progress
//             percent={currentUtilization}
//             status="active"
//             showInfo={false}
//             strokeColor={getUtilizationColor()}
//             style={{ marginTop: 4 }}
//           />
//           <div
//             style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               fontSize: 12,
//               marginTop: 4
//             }}
//           >
//             <Text type="secondary">Available: {availableUtilization}%</Text>
//             <Text type="secondary">Current: {currentUtilization}%</Text>
//           </div>
//         </div>

//         <Form.Item
//           label="Client"
//           name="client"
//           rules={[{ required: true, message: 'Please select a client' }]}
//         >
//           <Select
//             placeholder="Select Client"
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {clients.map((client) => (
//               <Option key={client.id} value={client.id}>
//                 {client.client_name}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item
//           label="Project"
//           name="project"
//           rules={[{ required: true, message: 'Please select a project' }]}
//         >
//           <Select
//             placeholder="Select Project"
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {projects.map((project) => (
//               <Option key={project.id} value={project.id}>
//                 {project.project}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         {/* Role Dropdown
//         <Form.Item
//           label="Role"
//           name="role"
//           rules={[{ required: true, message: 'Please select a role' }]}
//         >
//           <Select
//             placeholder="Select Role"
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {roles.map((role) => (
//               <Option key={role.id} value={role.id}>
//                 {role.role}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item> */}

//         <Form.Item
//           label={`Utilization (Max: ${availableUtilization}%)`}
//           name="allocation"
//           validateStatus={
//             allocationValue > availableUtilization ? 'warning' : undefined
//           }
//           help={
//             allocationValue > availableUtilization
//               ? `⚠ Allocation exceeds available limit of ${availableUtilization}%`
//               : null
//           }
//           rules={[
//             { required: true, message: 'Please enter allocation percentage' },
//             {
//               type: 'number',
//               min: 1,
//               message: `Must be at least 1%`
//             }
//           ]}
//           getValueFromEvent={(e) => {
//             const val = Number(e.target.value);
//             setAllocationValue(val);
//             return val;
//           }}
//         >
//           <Input
//             addonAfter="%"
//             type="number"
//             placeholder="Enter utilization"
//             min={1}
//           />
//         </Form.Item>

//         {/*Role Dropdown*/}
//         <Form.Item
//           label="Role"
//           name="role"
//           rules={[{ required: true, message: 'Please select a role' }]}
//         >
//           <Select
//             placeholder="Select Role"
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {roles.map((role) => (
//               <Option key={role.id} value={role.id}>
//                 {role.role}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         <Form.Item label="Utilization Type">
//           <Button.Group>
//             <Button
//               type={utilizationType === 'active' ? 'primary' : 'default'}
//               onClick={() => setUtilizationType('active')}
//             >
//               Active
//             </Button>
//             <Button
//               type={utilizationType === 'upcoming' ? 'primary' : 'default'}
//               onClick={() => setUtilizationType('upcoming')}
//             >
//               Upcoming
//             </Button>
//           </Button.Group>
//         </Form.Item>

//         <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
//           <Button
//             onClick={handleCancel}
//             className="font-bold border border-blue-500 text-blue-500"
//           >
//             Cancel
//           </Button>
//           <Button className="font-bold" type="primary" htmlType="submit">
//             Assign
//           </Button>
//         </div>
//       </Form>
//     </Modal>
//   );
// };

// export default AssignmentModal;

import React, { useEffect, useState } from 'react';
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  Progress,
  Avatar,
  Typography
} from 'antd';
import ColorHash from 'color-hash';
import { useDispatch } from 'react-redux';
import {
  fetchUserRoles,
  assignProjectToUser,
  fetchStaffingData,
  fetchStaffingUsers
} from '../redux/slice';
import { getAllProjects } from 'pages/Tasks/redux/slice';

const { Text } = Typography;
const { Option } = Select;
const colorHash = new ColorHash({ lightness: 0.7 });

const getInitials = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();
};

const AssignmentModal = ({ visible, open, onClose, member }) => {
  const [form] = Form.useForm();
  const [allocationValue, setAllocationValue] = useState(null);
  const [projects, setProjects] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [utilizationType, setUtilizationType] = useState('active');
  const isOpen = visible || open;
  const dispatch = useDispatch();

  const currentUtilization = member?.workload || 0;
  const availableUtilization = Math.max(0, 100 - currentUtilization);

  const uniqueClients = Array.from(
    new Map(
      projects.map((proj) => [
        proj.client.id,
        { id: proj.client.id, name: proj.client.client_name }
      ])
    ).values()
  );

  useEffect(() => {
    if (isOpen) {
      dispatch(getAllProjects()).then((res) => {
        if (res?.payload?.success) {
          setProjects(res.payload.data || []);
        }
      });

      dispatch(fetchUserRoles()).then((res) => {
        if (res?.payload?.success) {
          setRoles(res.payload.data || []);
        }
      });
    }
  }, [dispatch, isOpen]);

  const getUtilizationColor = () => {
    if (currentUtilization > 100) return '#ff4d4f';
    if (currentUtilization > 80) return '#faad14';
    return '#52c41a';
  };

  const handleFinish = (values) => {
    const payload = {
      project_id: values.project,
      user_id: member?.id,
      project_role_master_id: values.role,
      utilization_type: utilizationType,
      utilization_percentage: values.allocation
    };

    dispatch(assignProjectToUser(payload)).then((res) => {
      if (res?.payload?.success) {
        dispatch(fetchStaffingData());
        dispatch(fetchStaffingUsers());
      }
    });

    form.resetFields();
    onClose();
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const filteredProjects = selectedClient
    ? projects.filter((proj) => proj.client.id === selectedClient)
    : projects;

  return (
    <Modal
      visible={isOpen}
      onCancel={handleCancel}
      footer={null}
      centered
      destroyOnClose
      maskClosable
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <h3
          className="text-[rgba(0,0,0,0.85)]"
          style={{ fontWeight: 'bold', marginTop: '-7px' }}
        >
          Assign Project
        </h3>

        <Form.Item className="mb-[10px]">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Avatar
              style={{
                backgroundColor: member?.name
                  ? colorHash.hex(member.name)
                  : '#1677ff',
                color: '#fff',
                fontWeight: 600
              }}
            >
              {getInitials(member?.name)}
            </Avatar>
            <Text strong>{member?.name || 'Unknown User'}</Text>
          </div>
        </Form.Item>

        <div
          style={{
            marginBottom: 16,
            border: '1px solid #D1D5DB',
            padding: '6px 10px',
            borderRadius: '10px'
          }}
        >
          <Text>Current Utilization</Text>
          <Progress
            percent={currentUtilization}
            status="active"
            showInfo={false}
            strokeColor={getUtilizationColor()}
            style={{ marginTop: 4 }}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: 12,
              marginTop: 4
            }}
          >
            <Text type="secondary">Available: {availableUtilization}%</Text>
            <Text type="secondary">Current: {currentUtilization}%</Text>
          </div>
        </div>

        <Form.Item
          label="Client"
          name="client"
          rules={[{ required: true, message: 'Please select a client' }]}
        >
          <Select
            placeholder="Select Client"
            showSearch
            value={selectedClient}
            onChange={(val) => {
              setSelectedClient(val);
              form.setFieldsValue({ project: undefined }); // reset project
            }}
            optionFilterProp="children"
          >
            {uniqueClients.map((client) => (
              <Option key={client.id} value={client.id}>
                {client.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Project"
          name="project"
          rules={[{ required: true, message: 'Please select a project' }]}
        >
          <Select
            placeholder="Select Project"
            showSearch
            optionFilterProp="children"
            disabled={!selectedClient}
          >
            {filteredProjects.map((project) => (
              <Option key={project.id} value={project.id}>
                {project.project}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={`Utilization (Max: ${availableUtilization}%)`}
          name="allocation"
          validateStatus={
            allocationValue > availableUtilization ? 'warning' : undefined
          }
          help={
            allocationValue > availableUtilization
              ? `⚠ Allocation exceeds available limit of ${availableUtilization}%`
              : null
          }
          rules={[
            { required: true, message: 'Please enter allocation percentage' },
            {
              type: 'number',
              min: 1,
              message: 'Must be at least 1%'
            }
          ]}
          getValueFromEvent={(e) => {
            const val = Number(e.target.value);
            setAllocationValue(val);
            return val;
          }}
        >
          <Input
            addonAfter="%"
            type="number"
            placeholder="Enter utilization"
            min={1}
          />
        </Form.Item>

        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select
            placeholder="Select Role"
            showSearch
            optionFilterProp="children"
          >
            {roles.map((role) => (
              <Option key={role.id} value={role.id}>
                {role.role}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Utilization Type">
          <div className="flex gap-2">
            <Button
              style={{
                height: '24px',
                padding: '0px 10px 5px',
                backgroundColor:
                  utilizationType === 'active' ? '#0653fa' : undefined, // green
                color: utilizationType === 'active' ? 'white' : undefined,
                borderColor:
                  utilizationType === 'active' ? '#0653fa' : undefined
              }}
              type={utilizationType === 'active' ? 'default' : 'default'}
              onClick={() => setUtilizationType('active')}
            >
              Active
            </Button>
            <Button
              style={{
                height: '24px',
                padding: '0px 10px 5px',
                backgroundColor:
                  utilizationType === 'upcoming' ? '#0653fa' : undefined, // orange
                color: utilizationType === 'upcoming' ? 'white' : undefined,
                borderColor:
                  utilizationType === 'upcoming' ? '#0653fa' : undefined
              }}
              type={utilizationType === 'upcoming' ? 'default' : 'default'}
              onClick={() => setUtilizationType('upcoming')}
            >
              Upcoming
            </Button>
          </div>
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            onClick={handleCancel}
            className="font-bold border border-blue-500 text-blue-500"
          >
            Cancel
          </Button>
          <Button className="font-bold" type="primary" htmlType="submit">
            Assign
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AssignmentModal;
